import * as React from 'react';
import TextField from '@mui/material/TextField';
import MuiAutocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import { Input } from '../Input';

const filter = createFilterOptions<AutocompleteOption>();

interface AutocompleteProps {
    label: string
    options: AutocompleteOption[]
}

interface AutocompleteOption {
    label: string,
    value: string,
    inputValue?: string
}

export function Autocomplete({label, options}: AutocompleteProps) {
  const [value, setValue] = React.useState<AutocompleteOption | null>(null);

  return (
    <MuiAutocomplete
      value={value}
      onChange={(event, newValue) => {
        console.log(event, newValue)
        // if (typeof newValue === 'string') {
        //   setValue({
        //     label: newValue,
        //   });
        // } else if (newValue && newValue.inputValue) {
        //   // Create a new value from the user input
        //   setValue({
        //     label: newValue.inputValue,
        //   });
        // } else {
        //   setValue(newValue);
        // }
      }}
      filterOptions={(options, params) => {
        const filtered = filter(options, params);

        const { inputValue } = params;
        
        const isExisting = options.some((option) => inputValue === option.label);
        if (inputValue !== '' && !isExisting) {
          filtered.push({
            inputValue,
            label: `Adicionar "${inputValue}"`,
            value: 'CREATE_NEW'
          });
        }

        return filtered;
      }}
      selectOnFocus
      clearOnBlur
      handleHomeEndKeys
      options={options}
      getOptionLabel={(option) => {
        if (typeof option === 'string') {
          return option;
        }
        
        if (option.inputValue) {
          return option.inputValue;
        }
        
        return option.label;
      }}
      renderOption={(props, option) => {
        const { key, ...optionProps } = props;
        return (
          <li key={key} {...optionProps}>
            {option.label}
          </li>
        );
      }}
      freeSolo
      renderInput={(params) => (
        <Input {...params} label={label} />
      )}
    />
  );
}

interface FilmOptionType {
  inputValue?: string;
  title: string;
  year?: number;
}